import type { ActualSource } from '../trip-timeline.api';
import { SOURCE_LABELS } from '../policies/timeline-labels.policy';
import { clockText } from '../policies/timeline-time.policy';

/** One chip per source that recorded the fact; its tooltip says when that source says it happened. */
export function SourceChips({ sources, timezone }: { sources: ActualSource[]; timezone: string }) {
  return (
    <span className="flex flex-wrap gap-1.5">
      {sources.map((source) => (
        <span
          key={source.eventId}
          title={`${SOURCE_LABELS[source.kind]}: ${clockText(source.deviceTime, timezone)}`}
          className="rounded-full border border-line bg-surface px-2 py-0.5 text-xs text-muted"
        >
          {SOURCE_LABELS[source.kind]}
        </span>
      ))}
    </span>
  );
}
